(function () {
  // Wait for rd_cf_data
  function waitForObject() {
    return new Promise((resolve, reject) => {
      let counter = 0;
      const intervalId = setInterval(() => {
        if (window.rd_cf_data) {
          clearInterval(intervalId);
          resolve(window.rd_cf_data);
          console.log('rd_cf_data available');
        }
        counter++;
        if (counter >= 100) {
          clearInterval(intervalId);
          console.log('rd_cf_data not available');
        }
      }, 100);
    });
  }

  waitForObject().then((rd_cf_data) => {
    let inLA = window.rd_cf_data.city === 'Los Angeles';
    if (!inLA) {
      reOrderSection();
    }
  });

  function reOrderSection() {
    let personTitle = "In-Person  Experience";
    let virtualTitle = "Virtual One-on-One";
    let personSection, virtualSection;

    document.querySelectorAll(".title").forEach((titleElement) => {
      if (titleElement.textContent === personTitle) {
        personSection = titleElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement;
      } else if (titleElement.textContent === virtualTitle) {
        virtualSection = titleElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement;
      }
    });
    let personIndex, virtualIndex = -1;
    let mainContent = document.querySelector("#main-content");

    Array.from(mainContent.children).forEach((section, index) => {
      if (section.innerHTML.includes(personTitle)) {
        personIndex = index;
      } else if (section.innerHTML.includes(virtualTitle)) {
        virtualIndex = index;
      }
    });

    mainContent.insertBefore(virtualSection, personSection);
  }
})();